import React from "react";
import { Skeleton } from "@mui/material";
import { MuiBox } from "components/atoms";

const MoveFileFolderSkeleton = ({ rowCount = 6 }) => {
    return (
        <MuiBox
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}
        >
           
{/* 
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Skeleton variant="text" width={70} height={16} />
                <Skeleton variant="rounded" width={12} height={12} />
                <Skeleton variant="text" width={100} height={16} />
            </MuiBox> */}



            <MuiBox
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    maxHeight: "280px",
                    overflow: "hidden",
                }}
            >
                {/* <MuiBox
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        p: "8px",
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        width={20}
                        height={20}
                        sx={{ borderRadius: "4px", flexShrink: 0 }}
                    />
                    <Skeleton variant="text" width={90} height={16} />
                </MuiBox> */}
                {Array.from({ length: rowCount }).map((_, index) => (
                    <MuiBox
                        key={index}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: "8px",
                            borderRadius: "6px",
                        }}
                    >
                        <MuiBox
                            sx={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                                minWidth: 0,
                            }}
                        >
                            {/* <Skeleton
                                variant="rounded"
                                width={16}
                                height={16}
                                sx={{ borderRadius: "2px", flexShrink: 0 }}
                            /> */}
                            <Skeleton
                                variant="rounded"
                                width={20}
                                height={20}
                                sx={{ borderRadius: "4px", flexShrink: 0 }}
                            />
                            <Skeleton
                                variant="text"
                                width={380}
                                height={20}
                                sx={{ maxWidth: 340 }}
                            />
                        </MuiBox>

                        <MuiBox
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                flexShrink: 0,
                                width: "fit-content",
                            }}
                        >
                            <Skeleton
                                variant="rounded"
                                width={48}
                                height={20}
                                sx={{ borderRadius: "6px" }}
                            />
                            {/* <Skeleton
                                variant="rounded"
                                width={16}
                                height={16}
                                sx={{ borderRadius: "2px" }}
                            /> */}
                        </MuiBox>
                    </MuiBox>
                ))}
            </MuiBox>
        </MuiBox>
    );
};

export default MoveFileFolderSkeleton;